<template>
  <div class="container-list">
    <div class="flex">
      <unitList v-show="!($store.state.user.userInfo.natureId == 2)" @select="getUnit" @getFirst="getOne"></unitList>
      <div class="flex1">
        <div class="common-page common-head">
          <!-- <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        信息列表
      </div> -->
          <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
      </div>-->
        </div>
        <div class="common-page common-body">
          <div class="common-page common-tool-bar">
            <div class="btn"  style="margin-right: 10px;"  @click="showDia = true">
          <i class="icon-tr-search"></i>查询
        </div>
        <!-- <div class="btn ml10" @click="resetSearch">
          重置
        </div> -->
            <el-button type="info" size="small" v-hasPermi="['basic:dianwei:download']" plain @click="downmuban()">下载模板</el-button>

            <el-upload
              class="ml10"
              :action="$config.apiUrl + '/trxf/main/xf/danwei/dianwei/dianweiexcel'"
              :headers="{ token: $store.state.token }"
              :show-file-list="false"
              v-hasPermi="['basic:dianwei:import']"
              :on-success="handlesuccess"
            >
              <el-button size="small" type="success">导入文件</el-button>
            </el-upload>
            <el-button v-hasPermi="['basic:dianwei:export']" class="ml10" size="small" @click="output()" type="primary" plain>导出文件</el-button>

            <router-link v-hasPermi="['basic:dianwei:add']" class="btn ml20" :to="{ path: '/company/dianwei-add', query: { c_num: cpNum } }"> <i class="icon-tr-newly-added"></i>新增 </router-link>
          </div>
          <div class="common-page common-list">
            <el-table :data="list">
              <el-table-column prop="cz_dw_chuanshunum" label="传输设备编号" align="center"></el-table-column>
              <el-table-column prop="cz_dw_write" label="点位编号" align="center"></el-table-column>
              <el-table-column prop="cz_dw_miaoshu" label="点位地点" align="center"></el-table-column>

              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <router-link v-hasPermi="['basic:dianwei:edit']" :to="{ path: '/company/dianwei-add', query: { id: scope.row.cz_id, c_num: cpNum } }">
                    <el-button size="mini" type="warning">编辑</el-button>
                  </router-link>
                  <el-popconfirm
                    v-hasPermi="['basic:dianwei:remove']"
                    title="确定禁用此记录吗？"
                    class="cursor"
                    @confirm="changeStatus(scope.row.cz_id, 0)"
                    @onConfirm="changeStatus(scope.row.cz_id, 0)"
                  >
                    <a slot="reference" class="red">
                      <el-button type="danger" size="mini">删除</el-button>
                    </a>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination background layout="prev, pager, next" @current-change="pageChange" :page-size="10" :total="count"></el-pagination>
        </div>
        <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
          <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm"></fm-generate-form>
          <div class="center">
            <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
            <el-button @click="showDia = false" size="small">取消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import unitList from "@/components/unitList";
import config from "../../utils/config";
export default {
  components: {
    unitList,
  },
  data() {
    return {
      cpNum: "",
      showDia: false,
      searchForm: this.$getForm("qvyusearch1"),
      remoteFuncs: {},
      params: { c_company_num: "", page: 1,deviceNum:'', num:'', description:''  },
      list: [],
      count: 0,
      editData: {},
      c_num: this.$route.query.c_num,
      companyName: this.$route.query.name,
    };
  },
  created() {},
  mounted() {},
  watch: {
    cpNum() {
      this.params.c_company_num = this.cpNum;
      this.getList();
    },
  },

  methods: {
    getList() {
      this.$post("/trxf/main/xf/danwei/xfdanweixinxi/listdw", this.params).then((res) => {
        this.list = res.data.get_dianwei;
        this.count = res.data.count;
      });
    },
    output() {
      var url = `${config.apiUrl}/trxf/main/xf/danwei/dianwei/dianweidownload?c_company_num=${this.cpNum}`;
      window.open(url, "_blank");
    },
    downmuban() {
      var url = `${config.apiUrl}/trxf/main/xf/danwei/dianwei/downloadmoban?c_company_num=${this.cpNum}`;
      window.open(url, "_blank");
    }, //文件上传成功
    handlesuccess(res) {
      if (res.code == 500) {
        this.$message.error("导入失败，检查文件模板");
      } else {
        // this.$message.success("导入成功");
        this.$message({
									message: '导入成功',
									type: 'success',
									duration: 700,
								});
        this.getList();
      }
    },
    changeStatus(uuid) {
      this.$post(`/trxf/main/xf/danwei/xfdanweixinxi/deldw/${uuid}`)
        .then((res) => {
          // this.$message.success("删除成功");
          this.$message({
									message: '删除成功',
									type: 'success',
									duration: 700,
								});
          this.getList();
        })
        .catch((e) => {});
    },
    getOne(v) {
      this.cpNum = v;
    },
    getUnit(v) {
      this.cpNum = v;
    },
    resetSearch() {},
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss">
.f-list {
  flex-wrap: wrap;

  li {
    width: 240px;
    height: 280px;
    margin-right: 40px;
    margin-bottom: 40px;
  }
}

.com-warp {
  margin-top: 10px;

  li {
    font-size: 18px;
    line-height: 34px;
    color: #333;

    padding-left: 10px;
    opacity: 0.7;

    &:nth-child(odd) {
      background: #efeeff;
    }
  }
}

.tab-wrap {
  padding-bottom: 20px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
}

.f-left {
  width: 260px;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  height: 600px;
  margin-right: 30px;
}
</style>
